
export const SidebarMenu = {
  props: {
    target: String
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    for (const menu of jQuery('.accordions-list')) {
      const label = jQuery(menu).find('h3').text()
      if (menu.id && label) {
        this.list.push({
          id: menu.id,
          label: label,
        })
      }
    }
  },
  template: `
  <ul class="sidebar-menu d-lg-block d-none list-reset mt-4">
    <sidebar-menu-item v-for="item in list"
      :item="item"
      :isYellow="true"
      :key="item.id"></sidebar-menu-item>
  </ul>
  <div class="py-5 sidebar-menu__mobile">
    <accordion-select 
      v-if="list && list.length > 0"
      :list="list"></accordion-select>
  </div>
  `
}
